import classNames from 'clsx';
import CloudIcon from 'img/portal-menu/cloud.svg';
import CloudWhiteIcon from 'img/portal-menu/cloud-white.svg';
import LogoIconB2B from 'img/portal-menu/portal-menu__logo_vk-workdisk.svg?url';
import LogoIconB2BWhite from 'img/portal-menu/portal-menu__logo_vk-workdisk-contrast.svg?url';
import { ReactComponent as VKIcon } from 'img/portal-menu/vk.svg';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import styles from './Logo.css';

export enum ELogoSize {
    m = 'm',
    s = 's',
}

interface IProps {
    isBiz: boolean;
    isPhone: boolean;
    size?: ELogoSize;
    logoSrc?: string;
    white?: boolean;
    useRouterLink?: boolean;
}

export const LogoComponent: React.FC<IProps> = ({ isPhone, isBiz, size = ELogoSize.m, logoSrc, white, useRouterLink }): ReactElement => {
    const whiteLogo = white || isPhone;
    const logoSize = isPhone ? ELogoSize.s : size;
    const bizLogo = logoSrc || (whiteLogo ? LogoIconB2BWhite : LogoIconB2B);

    /* @ts-ignore */
    const icon = <img className={styles.logo} src={whiteLogo ? CloudWhiteIcon : CloudIcon} importance="high" />;

    return (
        <div className={classNames({ [styles.root]: true, [styles[`size_${logoSize}`]]: !!logoSize, [styles.root_white]: whiteLogo })}>
            {isBiz ? (
                <a href="/" className={styles.biz} title="VK WorkDisk">
                    {/* @ts-ignore */}
                    <img className={styles.logo} src={bizLogo} height={32} width={164} importance="high" />
                </a>
            ) : (
                <>
                    <a href="/" title="Облако Mail.ru" className={styles.cloud}>
                        {useRouterLink ? <Link to="/">{icon}</Link> : icon}
                    </a>
                    <a href="https://trk.mail.ru/c/o90pw9" className={styles.vk} target="_blank" title="Экосистема VK" rel="noreferrer">
                        <VKIcon className={styles.endorsment} />
                    </a>
                </>
            )}
        </div>
    );
};
